import { useState, useCallback } from 'react';

// The last ten timestamped messages shown by the "Debug" toggle in the Voice panel.
export default function useDebugLog() {
  const [debugLog, setDebugLog] = useState([]);

  const addDebugLog = useCallback((message) => {
    const timestamp = new Date().toLocaleTimeString();
    setDebugLog(prev => [...prev, `[${timestamp}] ${message}`].slice(-10));
  }, []);

  return { debugLog, addDebugLog };
}
